import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { TRootStackParamList } from '../types/exportedTypes';

export const Stack = createNativeStackNavigator<TRootStackParamList>();
